import React from 'react'

const FeeCollection = () => {
  return (
    <div>FeeCollection</div>
  )
}

export default FeeCollection